import { forwardRef } from 'react'
import { Select as ChakraSelect, SelectProps } from '@chakra-ui/react'
import { FormControl } from 'components'
import { Option } from 'types/input'

type Props = SelectProps & {
  options: Option[]
  label?: string
  helperText?: string
}

export const Select = forwardRef<HTMLInputElement, Props>(
  ({ options, label, helperText, ...props }, ref) => {
    return (
      <FormControl label={label} helperText={helperText}>
        <ChakraSelect ref={ref} {...props}>
          {options.map((option: Option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </ChakraSelect>
      </FormControl>
    )
  },
)

Select.displayName = 'Select'
